import React, { useMemo, useEffect, useState } from 'react';
import { Grid, Icon, Message, MessageContent, MessageHeader } from 'semantic-ui-react';
import './SessionMessage.less';
import { isAllLocations } from '../../../helpers/utils';

const SessionMessage = () => {
    const [allLocationsBanner, setAllLocationsBanner] = useState(sessionStorage.getItem('allLocationsBanner'));

    useEffect(() => {
        const handleStorageChange = () => {
            setAllLocationsBanner(sessionStorage.getItem('allLocationsBanner'));
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const isVisible = useMemo(() => {
        return allLocationsBanner !== 'dismissed' && isAllLocations();
    }, [allLocationsBanner, isAllLocations()]);

    const onDismissMessage = () => {
        sessionStorage.setItem('allLocationsBanner', 'dismissed');
        setAllLocationsBanner('dismissed');
    };

    return (
        isVisible && (
            <Grid.Row className="all-locations-banner html-to-image-ignore">
                <Grid.Column computer="12" mobile="12">
                    <Message size="big" icon color="yellow" className="all-locations-message" onDismiss={onDismissMessage}>
                        <Icon name="warning" />
                        <MessageContent data-test-id="allLocationsMessage">
                            <MessageHeader data-test-id="allLocationsHeader">Limited view while in All Locations</MessageHeader>
                            Certain sections of the portal do not support the <strong>All Locations</strong> option. Select a single location to view
                            the entire portal again.
                        </MessageContent>
                    </Message>
                </Grid.Column>
            </Grid.Row>
        )
    );
};

export default SessionMessage;
